import { ArrowRightIcon } from "@t8891/icon";
import React from "react";
import { itemIdValueEqual } from "utils/InquiryLogistics";

const SelectItem: React.FC<any> = ({ press, label, arrow, onClick }) => {
  return (
    <div
      className={`${
        press ? "text-[#fff] bg-[#3264FF] font-bold" : "text-[#333] hover:text-[#333] hover:bg-[#F5F5F5]"
      }  flex items-center min-h-40 text-14 px-14 justify-between cursor-pointer`}
      onClick={onClick}
    >
      {label}
      {arrow && <ArrowRightIcon size={32} />}
    </div>
  );
};
export default SelectItem;
